import { createFileRoute } from '@tanstack/react-router';
import { useEffect } from 'react';

import { CampaignList } from '@/features/meta-campaigns';
import { useIsMobile } from '@/hooks/use-mobile';

export const Route = createFileRoute(
  '/_authed/dashboard/l/$locationId/marketing/advertising/'
)({
  validateSearch: (
    search: Record<string, unknown>
  ): { campaign?: string; ad?: string; create?: boolean } => ({
    campaign: typeof search.campaign === 'string' ? search.campaign : undefined,
    ad: typeof search.ad === 'string' ? search.ad : undefined,
    create:
      search.create === true || search.create === 'true' ? true : undefined,
  }),
  component: AdvertisingIndexPage,
});

/**
 * The advertising campaigns index. `CampaignList` renders on the shared
 * `ListPage`, which owns the header, the search row and the phone layout.
 * Desktop opens a campaign on its own page; phones keep the side panel.
 */
function AdvertisingIndexPage() {
  const { campaign, ad, create } = Route.useSearch();
  const navigate = Route.useNavigate();
  const { locationId } = Route.useParams();
  // Phones keep main's flow: a campaign opens in the side panel over this
  // list. Desktop opens the campaign's own page.
  const isMobile = useIsMobile();
  useEffect(() => {
    if (!campaign) return;
    if (isMobile)
      // CampaignList opens the panel from `initialCampaignId`; consume the
      // selection so following the same link again can reopen it.
      void navigate({
        search: (previous) => ({
          ...previous,
          campaign: undefined,
          ad: undefined,
        }),
        replace: true,
      });
    else
      void navigate({
        to: '/dashboard/l/$locationId/marketing/advertising/$id',
        params: { locationId, id: campaign },
        search: { ad },
        replace: true,
      });
  }, [campaign, ad, isMobile, locationId, navigate]);
  return (
    <>
      <title>Advertising | Borrah</title>
      <CampaignList
        onCampaignSelect={
          isMobile
            ? undefined
            : (id) =>
                void navigate({
                  to: '/dashboard/l/$locationId/marketing/advertising/$id',
                  params: { locationId, id },
                  search: {},
                })
        }
        initialCampaignId={isMobile ? campaign : undefined}
        initialAdId={isMobile ? ad : undefined}
        initialCreateOpen={create}
      />
    </>
  );
}
